/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ClasseMatiereSearch
 */
export interface ClasseMatiereSearch {
    /**
     * 
     * @type {number}
     * @memberof ClasseMatiereSearch
     */
    idClasse?: number;
    /**
     * 
     * @type {number}
     * @memberof ClasseMatiereSearch
     */
    idFormateur?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClasseMatiereSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ClasseMatiereSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseMatiereSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseMatiereSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ClasseMatiereSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClasseMatiereSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ClasseMatiereSearch interface.
 */
export function instanceOfClasseMatiereSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClasseMatiereSearchFromJSON(json: any): ClasseMatiereSearch {
    return ClasseMatiereSearchFromJSONTyped(json, false);
}

export function ClasseMatiereSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClasseMatiereSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idClasse': !exists(json, 'idClasse') ? undefined : json['idClasse'],
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ClasseMatiereSearchToJSON(value?: ClasseMatiereSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idClasse': value.idClasse,
        'idFormateur': value.idFormateur,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

